import { Segmented } from 'antd';
import { BorderRightOutlined, BlockOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import styles from './DetailPreferenceToggle.module.scss';

const OPTIONS = [
  { value: 'aside', label: 'Panneau', icon: <BorderRightOutlined /> },
  { value: 'modal', label: 'Fenêtre', icon: <BlockOutlined /> },
];

const DESCRIPTIONS = {
  aside: 'Les détails s\'ouvrent dans un panneau latéral sans quitter la liste.',
  modal: 'Les détails s\'ouvrent dans une fenêtre centrée au-dessus de la liste.',
};

export default function DetailPreferenceToggle({ mode, onChange }) {
  return (
    <div className={styles.bar}>
      <div className={styles.left}>
        <span className={styles.label}>Affichage des détails</span>
        <Segmented
          size="small"
          value={mode}
          onChange={onChange}
          options={OPTIONS}
          className={styles.segmented}
        />
      </div>
      <p className={styles.description}>{DESCRIPTIONS[mode]}</p>
    </div>
  );
}

DetailPreferenceToggle.propTypes = {
  mode: PropTypes.oneOf(['aside', 'modal']).isRequired,
  onChange: PropTypes.func.isRequired,
};
